<div class="vulnerable-badge text-12-medium">
  <i class="material-icons">{{ iconName }}</i> <span>{{ label }}</span>
</div>
